export default __webpack_public_path__ + "static/media/Fish_School_6.ba27b266.gif";